import React, { FC } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { ProductCategoryModel, ProductModel } from '../../../../../shared/orders/product';
import { PageHeader, UserStateComponent } from '../../../../components';
import { useTranslation } from '../../../../translations';
import { Fetcher, useBoolState, useFetcher } from '../../../../utils';
import { CategoryCreateProduct } from './categoryCreateProduct';
import { CategoryInfo } from './categoryInfo';

interface LoadingData {
  category: ProductCategoryModel;
  products: ProductModel[];
}

export const CategoryView: FC = () => {
  const { params } = useRouteMatch<{ id: string }>();
  const [isCreate, enableIsCreate, disabledIsCreate] = useBoolState(false);
  const { ts } = useTranslation();

  const id = Number.parseInt(params.id, 10);

  const fetch = useFetcher(async (): Promise<LoadingData> => {
    const [category, products] = await Promise.all([
      api.getProductCategoryById(id),
      api.getFullProductsByCategory(id),
    ]);

    return { category, products };
  }, [id]);

  return (
    <UserStateComponent>
      {fetch.data ? (
        <>
          <PageHeader>
            {ts('category')}: {fetch.data.category.name}
          </PageHeader>
          {isCreate ? (
            <CategoryCreateProduct
              categoryId={fetch.data.category.id}
              onToggle={disabledIsCreate}
            />
          ) : (
            <CategoryInfo
              categoryId={fetch.data.category.id}
              onToggle={enableIsCreate}
              products={fetch.data.products}
            />
          )}
        </>
      ) : (
        <Fetcher result={fetch} />
      )}
    </UserStateComponent>
  );
};
